import React from "react";
const SvgFilterArrow = props => (
  <svg viewBox="0 0 14 8" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M7 8a.703.703 0 01-.508-.218L.197 1.2A.713.713 0 01.216.197a.705.705 0 01.997.02L7 6.267l5.787-6.05a.705.705 0 01.997-.02c.28.272.289.72.019 1.003L7.508 7.782A.703.703 0 017 8"
    />
  </svg>
);
export default SvgFilterArrow;
